export const TOOL_CALL_DESCRIPTION_FIELD = "toolCallDescription";
